import React, {useMemo, useEffect, useState} from 'react';
import { Link } from 'react-router-dom';

const Appointments = (props) => {

    const [state, setState] = useState([]);

    // useMemo(() => {
    // //   if (state) {
    // //   }
    //   setState(props.appointmentsList);
    //   console.log('This is something bro here',props.appointmentsList);

    // }, [props]);

    useEffect(() => {
        setState(props.appointmentsList);
        console.log('im HEREr ',props.appointmentsList);
    }, [props])

    return (
        <div className="appointments_top">
           {state.length === 0 ? <h3>No Today's Appointments Yet</h3> : 

           <ul>
               {state && state.map((item) => {
                return (
                item.status === "awaiting" && <li key={item && item.id}>
                    <Link to={`/attending_patient/${item.patient && item.patient.id}/${item && item.id}`}>
                        <h4>{item.token}</h4>
                        <h5>{item.patient && item.patient.fullName} <span>{item.patient && item.patient.contactNumber}</span></h5>
                        <button className='btn attend'>Attend</button>
                    </Link>
                </li>)
               })}
           </ul>
           
            }
        </div>
    );
}

export default Appointments;
